import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from 'react-bootstrap';
import logo from '../../../../src/images/LOGO.png';
import noProfileImage from '../../../../src/images/no-profile.png';
import { Link, NavLink } from "react-router";
import { logoutUser } from "../../../Redux/Actions/AuthActions";

import { IoChevronDownOutline } from "react-icons/io5";

const Navbar = () => {

    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const rebrandData = useSelector(state => state.rebrand.data);
    const [isActive, setActive] = useState("false");
    const [memberShip, setMemberShip] = useState([])



    const handleToggle = () => {
        setActive(!isActive);
    };

    const logout = () => {
        dispatch(logoutUser());
    }

    useEffect(() => {
        if (auth.user) {
            setMemberShip(auth.user.membership.split("__"))
        }
    }, [auth.user])



    return (
        <>

            <header className="appHeader">
                <div className="appHeader-wrap">
                    <div className="appHeader-main">

                        <div className="logo-full">
                            <Link to={'/dashboard'}><img className={`${rebrandData ? "logo-image-set" : ""} img-fluid`} src={rebrandData ? rebrandData.logo : logo} /></Link>
                        </div>

                        <div className="navExpand" onClick={handleToggle}><i className="fa fa-bars" aria-hidden="true"></i></div>

                        <div className="appHeader-left">
                            {/* <h2 className="pageTitle gradientTxt"><span>Page Title Here</span></h2> */}
                        </div>

                        <div className={`appHeader-right ${!isActive ? "act" : ""}`}>

                            <div className="appHeader-nav d-none">
                                {/* <ul>
                                    <li><NavLink className="nav-link" to="/dashboard" activeClassName="active">Dashboard</NavLink></li>
                                    <li><NavLink className="nav-link" to="/courses" activeClassName="active">Courses</NavLink></li>
                                    {
                                        +auth.user.isClientAccount === 0 ?
                                            <li className="nav-item">
                                                <NavLink className="nav-link" to="/integration">Integrations</NavLink>
                                            </li>
                                            : ''
                                    }
                                    <li className="nav-item"><NavLink className="nav-link" to="/help-and-support">Help</NavLink></li> 
                                </ul> */}

                                <div className='link-list'>
                                    <ul>
                                        <li><NavLink to="/dashboard"><span><img src={require('../../../images/dashboard/dashboard.svg').default} alt="" /></span> Dashboard</NavLink></li>
                                        <li><NavLink to="/courses"><span><img src={require('../../../images/dashboard/courses.svg').default} alt="" /></span> Courses</NavLink></li>
                                        <li><NavLink to="/promo-video"><span><img src={require('../../../images/dashboard/promo.svg').default} alt="" /></span> Promo Video</NavLink></li>

                                        <li><a><span><img src={require('../../../images/dashboard/quiz-maker.svg').default} alt="" /></span> Quiz <span style={{ marginLeft: 'auto' }}><IoChevronDownOutline /></span></a>
                                            <ul>
                                                <li>
                                                    <NavLink to="/quiz-generation"><span><img src={require('../../../images/dashboard/quiz-response.svg').default} alt="" /></span> Quiz Maker</NavLink>
                                                </li>
                                                {/* <li>
                                                  <NavLink to="/review-participants"><span><img src={require('../../../images/dashboard/quiz-response.svg').default} alt="" /></span> Quiz Response</NavLink>
                                                </li> */}
                                                <li>
                                                    <NavLink to="/participants"><span><img src={require('../../../images/dashboard/participants.svg').default} alt="" /></span> Participants</NavLink>
                                                </li>
                                            </ul>
                                        </li>

                                        <li><NavLink to="/landing-page"><span><img src={require('../../../images/dashboard/landing.svg').default} alt="" /></span> Landing Page</NavLink></li>
                                        {+auth.user.isClientAccount === 1 ? null :
                                            <li><NavLink to="/integration"><span><img src={require('../../../images/dashboard/integration.svg').default} alt="" /></span> Integrations</NavLink></li>}
                                    </ul>
                                </div>
                            </div>
                            <div className="appHeader-action">

                                <div className="action-nav">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="" id="dropdown-basic2">
                                            <div className="dropProfileImage"><img src={auth.user ? auth.user.profile : noProfileImage} /></div>
                                            <div>
                                                <span className="welcometxt">Welcome</span>
                                                <span className="profileName">{auth.user?.name}</span>
                                            </div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdown-menu-dark">
                                            {
                                                +auth.user.isClientAccount === 1 ? "" :
                                                    <Link className="dropdown-item" to="/my-account">
                                                        <span className="mr-2"><i className="fas fa-user"></i></span> My Account
                                                    </Link>
                                            }
                                            {
                                                +auth.user.isClientAccount === 0 && +auth.user.isVirtualAccount === 0 ?
                                                    <>

                                                        <Link className="dropdown-item" to="/privacy">
                                                            <span className="mr-2"><i className="fas fa-key"></i></span> Privacy Setting
                                                        </Link>
                                                        {
                                                            memberShip.includes("business") || memberShip.includes("bundle") || memberShip.includes("fastpass") ?
                                                                <>
                                                                    <Link className="dropdown-item" to="/account-management">
                                                                        <span className="mr-2"><i className="fas fa-users" ></i></span>
                                                                        Account Management
                                                                    </Link>
                                                                </> : ''
                                                        }
                                                    </>
                                                    : ''
                                            }
                                            {
                                                +auth.user.isClientAccount === 0 ?
                                                    memberShip.includes("dfy") || memberShip.includes("business") || memberShip.includes("bundle") || memberShip.includes("fastpass") || memberShip.includes("unlimitedlite") || memberShip.includes("unlimited") ?
                                                        <Link className="dropdown-item" to="/upgrades">
                                                            <span className="mr-2"><i className="fas fa-plus-square"></i></span> Upgrades
                                                        </Link> : ''
                                                    : ''
                                            }
                                            {
                                                +auth.user.isClientAccount === 0 && +auth.user.isVirtualAccount === 0 ?
                                                    (memberShip.includes("professional") || memberShip.includes("bundle") || memberShip.includes("fastpass")) ?
                                                        <Link to='/reel-merge' className="dropdown-item">
                                                            <span className="mr-2">
                                                                <i className="fas fa-sign-out-alt"></i>
                                                            </span> Reel Merge
                                                        </Link> : "" : ""
                                            }
                                            <Link className="dropdown-item" to="/help-and-support">
                                                <span className="mr-2"><i className="fas fa-headset"></i></span> Help & Support
                                            </Link>
                                            <span className="dropdown-divider"></span>
                                            <a className="dropdown-item" style={{cursor:"pointer"}} onClick={() => logout()}>
                                                <span className="mr-2">
                                                    <i className="fas fa-sign-out-alt"></i>
                                                </span> Sign Out
                                            </a>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}


export default React.memo(Navbar);